// Autogenerated during build time. Do not modify.
export const RICOS_VERSION = '10.99.1';
//# sourceMappingURL=version.js.map